module.exports = __webpack_public_path__ + "static/media/terreno.7ceb85c5.jpg";